// apps/share-web/src/song-screen/gestures.ts
//
// Распознаватели жестов без DOM. Почему свои, а не dblclick/contextmenu браузера:
// iOS Safari не присылает dblclick на двойной ТАП, а долгое нажатие на ссылке/
// тексте вызывает системное меню. Один счётчик тапов работает одинаково для
// мыши и пальца: двойной клик на компьютере и двойной тап на телефоне.

export interface TapTracker {
  /** 'double', если тот же ключ пришёл в пределах окна и допуска; иначе 'single'. */
  tap(key: string, x: number, y: number, now: number): 'single' | 'double';
  reset(): void;
}

export function createTapTracker(windowMs = 320, slopPx = 10): TapTracker {
  let last: { key: string; x: number; y: number; t: number } | null = null;
  return {
    tap(key, x, y, now) {
      if (last && last.key === key && now - last.t >= 0 && now - last.t <= windowMs && Math.hypot(x - last.x, y - last.y) <= slopPx) {
        last = null; // третий тап начинает новую пару, а не снова «двойной»
        return 'double';
      }
      last = { key, x, y, t: now };
      return 'single';
    },
    reset() { last = null; },
  };
}

export type Axis = 'pending' | 'x' | 'y';

/** Захват оси: пока сдвиг меньше порога — 'pending'; дальше по большей проекции (ничья — x). */
export function lockAxis(dx: number, dy: number, thresholdPx: number): Axis {
  if (Math.max(Math.abs(dx), Math.abs(dy)) < thresholdPx) return 'pending';
  return Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
}

export interface LongPress {
  down(x: number, y: number): void;
  move(x: number, y: number): void;
  /** Палец поднят. true — если долгое нажатие успело сработать. */
  up(): boolean;
  /**
   * Сбросить ожидание. Потребитель обязан звать его на pointercancel и при
   * размонтировании, иначе таймер сработает уже без пальца на экране.
   */
  cancel(): void;
}

export interface LongPressOpts {
  ms?: number;
  slopPx?: number;
  onFire: () => void;
}

export function createLongPress(o: LongPressOpts): LongPress {
  const ms = o.ms ?? 450;
  const slop = o.slopPx ?? 8;
  let timer: ReturnType<typeof setTimeout> | null = null;
  let x0 = 0;
  let y0 = 0;
  let fired = false;
  const stop = (): void => { if (timer !== null) { clearTimeout(timer); timer = null; } };
  return {
    down(x, y) {
      stop(); fired = false; x0 = x; y0 = y;
      timer = setTimeout(() => { timer = null; fired = true; o.onFire(); }, ms);
    },
    move(x, y) { if (timer !== null && Math.hypot(x - x0, y - y0) > slop) stop(); },
    up() { stop(); const f = fired; fired = false; return f; },
    cancel() { stop(); fired = false; },
  };
}
